import React from 'react';
import { sprintf } from 'sprintf';

type Props = {
  onBack: () => void;
};

export const LoginSection: React.FC<Props> = (props) => {
  return (
    <div className='text-center px-1'>
      <div className='icon-checkmark color-ok fs-32' />
      <h1 className='standfirst standfirst--lead lh-tight mb-1 mb-sm-3'>Voucher code accepted</h1>
      <p className='fs-16 lh-regular mb-2'>
        {sprintf(
          'Please create an account or log in to receive your free %s subscription',
          'Art\u00A0Stream',
        )}
      </p>
      <div className='mb-1'>
        <a href={Routes.signup_path()} className='btn btn--border js-show-signup-modal'>
          Sign Up
        </a>
        <a href={Routes.login_path()} className='btn btn--border js-show-login-modal'>
          Log In
        </a>
      </div>
      <a
        href='#'
        onClick={(event) => {
          event.preventDefault();
          props.onBack();
        }}
        className='link-border link-border--back'
      >
        <span className='link-border'>start over</span>
      </a>
    </div>
  );
};
